<template>
    <ModalOverlay v-if="show" @click.stop>
        <ModalContent @click.stop>
            <ModalHeader>
                <ModalTitle>회사 정보 수정</ModalTitle>
                <CloseButton @click="closeModal">&times;</CloseButton>
            </ModalHeader>

            <ModalBody>
                <FormContainer>
                    <FormRow>
                        <FormGroup>
                            <FormLabel required>회사명</FormLabel>
                            <FormInput v-model="formData.name" placeholder="회사명을 입력하세요" required
                                :class="{ 'blurred': isTestUser }" />
                        </FormGroup>
                        <FormGroup>
                            <FormLabel required>대표자</FormLabel>
                            <FormInput v-model="formData.ceo_name" placeholder="대표자명을 입력하세요" required
                                :class="{ 'blurred': isTestUser }" />
                        </FormGroup>
                        <FormGroup>
                            <FormLabel required>회사 이메일</FormLabel>
                            <FormInput v-model="formData.company_email" placeholder="회사 이메일을 입력하세요" required
                                :class="{ 'blurred': isTestUser }" />
                        </FormGroup>
                    </FormRow>

                    <FormRow>
                        <FormGroup>
                            <FormLabel>회사 번호</FormLabel>
                            <FormInput v-model="formData.phone" placeholder="회사 번호를 입력하세요"
                                :class="{ 'blurred': isTestUser }" />
                        </FormGroup>
                        <FormGroup>
                            <FormLabel>기관 번호</FormLabel>
                            <FormInput v-model="formData.cnum" placeholder="기관 번호를 입력하세요"
                                :class="{ 'blurred': isTestUser }" />
                        </FormGroup>
                        <FormGroup>
                            <FormLabel>사업자등록번호</FormLabel>
                            <FormInput v-model="formData.bnum" placeholder="사업자 등록 번호를 입력하세요"
                                :class="{ 'blurred': isTestUser }" />
                        </FormGroup>
                    </FormRow>

                    <FormRow>
                        <FormGroup>
                            <FormLabel>대표자 전화번호</FormLabel>
                            <FormInput v-model="formData.ceo_phone" placeholder="대표자 전화번호를 입력하세요"
                                :class="{ 'blurred': isTestUser }" />
                        </FormGroup>
                        <FormGroup>
                            <FormLabel>종목</FormLabel>
                            <FormInput v-model="formData.type" placeholder="사업소 종목을 입력하세요"
                                :class="{ 'blurred': isTestUser }" />
                        </FormGroup>
                        <FormGroup>
                            <FormLabel>업태</FormLabel>
                            <FormInput v-model="formData.industry" placeholder="사업소 업태를 입력하세요"
                                :class="{ 'blurred': isTestUser }" />
                        </FormGroup>
                    </FormRow>

                    <FormRow>
                        <FormGroup>
                            <FormLabel>팩스 번호</FormLabel>
                            <FormInput v-model="formData.fax" placeholder="팩스 번호를 입력하세요" :class="{ 'blurred': isTestUser }" />
                        </FormGroup>
                        <FormGroup>
                            <FormLabel>공인인증서 아이디</FormLabel>
                            <FormInput v-model="formData.certificate_id" placeholder="공인인증서 아이디를 입력하세요"
                                :class="{ 'blurred': isTestUser }" />
                        </FormGroup>
                        <FormGroup>
                            <FormLabel>공인인증서 암호</FormLabel>
                            <FormInput v-model="formData.certificate_pw" type="password"
                                placeholder="공인인증서 암호를 입력하세요" :class="{ 'blurred': isTestUser }" />
                        </FormGroup>
                    </FormRow>

                    <FormRow>
                        <FormGroup fullWidth>
                            <FormLabel required>사업장 주소</FormLabel>
                            <div>
                                <FormInput v-model="formData.address" placeholder="사업장 주소를 입력하세요" style="width: 320px;"
                                    readonly :class="{ 'blurred': isTestUser }" />
                                <AddressSearchButton @click="searchAddress">주소 검색</AddressSearchButton>
                            </div>
                            <FormInput v-model="formData.address_detail" placeholder="상세주소를 입력하세요"
                                style="margin-top: 8px;" :class="{ 'blurred': isTestUser }" />
                        </FormGroup>
                    </FormRow>
                </FormContainer>
            </ModalBody>

            <ModalFooter>
                <CancelButton @click="closeModal">취소</CancelButton>
                <SaveButton @click="saveCompany">저장하기</SaveButton>
            </ModalFooter>
        </ModalContent>
    </ModalOverlay>
</template>

<script>
import * as CompanyModalCss from '@/assets/styles/manage/modal/CompanyModalCss.js';

export default {
    name: 'CompanyModal',

    components: {
        ...CompanyModalCss
    },

    props: {
        show: {
            type: Boolean,
            default: false
        },
        companyData: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            formData: {
                name: '',
                ceo_name: '',
                ceo_phone: '',
                company_email: '',
                cnum: '',
                phone: '',
                fax: '',
                type: '',
                industry: '',
                ceo_email: '',
                address: '',
                address_detail: '',
                bnum: '',
                certificate_id: '',
                certificate_pw: '',
            }
        };
    },

    watch: {
        show(newVal) {
            if (newVal) {
                this.initializeForm();
                this.addEscapeKeyListener();
            } else {
                this.removeEscapeKeyListener();
            }
        },
        companyData: {
            handler(newVal) {
                if (newVal && Object.keys(newVal).length > 0) {
                    this.initializeForm();
                }
            },
            deep: true
        }
    },

    computed: {
        isTestUser() {
            try {
                const userInfo = JSON.parse(localStorage.getItem('userInfo'));
                return userInfo && userInfo.id === 'test';
            } catch (error) {
                return false;
            }
        },
    },

    methods: {
        initializeForm() {
            if (this.companyData) {
                this.formData = {
                    name: this.companyData.name || '',
                    ceo_name: this.companyData.ceo_name || '',
                    ceo_phone: this.companyData.ceo_phone || '',
                    company_email: this.companyData.company_email || '',
                    cnum: this.companyData.cnum || '',
                    phone: this.companyData.phone || '',
                    fax: this.companyData.fax || '',
                    type: this.companyData.type || '',
                    industry: this.companyData.industry || '',
                    ceo_email: this.companyData.ceo_email || '',
                    address: this.companyData.address || '',
                    address_detail: this.companyData.address_detail || '',
                    bnum: this.companyData.bnum || '',
                    certificate_id: this.companyData.certificate_id || '',
                    certificate_pw: this.companyData.certificate_pw || '',
                };
            }
        },

        validateForm() {
            // 문자열 필드들
            const name = String(this.formData.name || '').trim();
            const ceo_name = String(this.formData.ceo_name || '').trim();
            const ceo_phone = String(this.formData.ceo_phone || '').trim();
            const company_email = String(this.formData.company_email || '').trim();
            const phone = String(this.formData.phone || '').trim();
            const fax = String(this.formData.fax || '').trim();
            const type = String(this.formData.type || '').trim();
            const industry = String(this.formData.industry || '').trim();
            const address = String(this.formData.address || '').trim();

            // 숫자 필드들 (int 타입)
            const cnum = this.formData.cnum;
            const bnum = this.formData.bnum;

            if (!name) {
                this.$swal.fire('오류', '회사명을 입력해주세요.', 'error');
                return false;
            }

            if (!ceo_name) {
                this.$swal.fire('오류', '대표자명을 입력해주세요.', 'error');
                return false;
            }

            if (!ceo_phone) {
                this.$swal.fire('오류', '대표자 번호를 입력해주세요.', 'error');
                return false;
            }

            if (!company_email) {
                this.$swal.fire('오류', '기관 이메일을 입력해주세요.', 'error');
                return false;
            }

            if (!cnum || cnum === 0) {
                this.$swal.fire('오류', '기관번호를 입력해주세요.', 'error');
                return false;
            }

            if (!phone) {
                this.$swal.fire('오류', '기관 전화번호를 입력해주세요.', 'error');
                return false;
            }

            if (!fax) {
                this.$swal.fire('오류', '팩스 번호를 입력해주세요.', 'error');
                return false;
            }

            if (!type) {
                this.$swal.fire('오류', '사업소 종목을 입력해주세요.', 'error');
                return false;
            }

            if (!industry) {
                this.$swal.fire('오류', '사업소 업태를 입력해주세요.', 'error');
                return false;
            }

            if (!address) {
                this.$swal.fire('오류', '사업장 주소를 입력해주세요.', 'error');
                return false;
            }

            if (!bnum || bnum === 0) {
                this.$swal.fire('오류', '사업자 등록번호를 입력해주세요.', 'error');
                return false;
            }

            return true;
        },

        async saveCompany() {
            if (!this.validateForm()) {
                return;
            }

            try {
                const companykey = this.$globalState.company_key;
                if (!companykey) {
                    this.$swal.fire('오류', '회사 정보를 찾을 수 없습니다.', 'error');
                    return;
                }

                // 주소와 상세주소를 합쳐서 address로 전달
                const fullAddress = this.formData.address_detail
                    ? `${this.formData.address} ${this.formData.address_detail}`.trim()
                    : this.formData.address;

                const response = await this.$axios({
                    method: 'put',
                    url: `${this.$apiUrls.hanqmedi}/updateCompanyInfo`,
                    data: {
                        ...this.formData,
                        address: fullAddress,
                        companykey
                    }
                });

                if (response.data.success) {
                    this.$swal.fire('성공', '회사 정보가 수정되었습니다.', 'success');
                    this.$emit('save', this.formData);
                } else {
                    this.$swal.fire('오류', response.data.message || '회사 정보 수정에 실패했습니다.', 'error');
                }
            } catch (error) {
                console.error('회사 정보 수정 오류:', error);
                this.$swal.fire('오류', '회사 정보 수정 중 오류가 발생했습니다.', 'error');
            }
        },

        // 주소 검색
        searchAddress() {
            if (window.daum && window.daum.Postcode) {
                new window.daum.Postcode({
                    oncomplete: (data) => {
                        this.formData.address = data.address;
                        this.formData.address_detail = '';
                    }
                }).open();
            } else {
                this.$swal.fire('오류', '주소 검색 서비스를 사용할 수 없습니다.', 'error');
            }
        },

        // ESC 키 이벤트 리스너 추가
        addEscapeKeyListener() {
            document.addEventListener('keydown', this.handleEscapeKey);
        },

        // ESC 키 이벤트 리스너 제거
        removeEscapeKeyListener() {
            document.removeEventListener('keydown', this.handleEscapeKey);
        },

        // ESC 키 처리
        handleEscapeKey(event) {
            if (event.key === 'Escape' && this.show) {
                this.closeModal();
            }
        },

        closeModal() {
            this.removeEscapeKeyListener();
            this.$emit('close');
        }
    },

    // 컴포넌트가 제거될 때 이벤트 리스너 정리
    beforeUnmount() {
        this.removeEscapeKeyListener();
    }
};
</script>

<style>
.blurred {
    filter: blur(4px) !important;
    pointer-events: auto;
    user-select: auto;
    -webkit-user-select: auto;
    -moz-user-select: auto;
    -ms-user-select: auto;
}
</style>